import { Observable, of } from 'rxjs'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  RouterStateSnapshot,
} from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import { IsDataLoaded } from '@tokeet/tv3-platform'
import { selectInvoiceRulesLoaded } from './rule.selectors'
import { LoadInvoiceRules } from './rule.actions'

@Injectable({ providedIn: 'root' })
export class InvoiceRuleGuard implements CanActivate, CanActivateChild, CanLoad, IsDataLoaded {
  constructor(private store: Store<any>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectInvoiceRulesLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(LoadInvoiceRules())
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate()
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
